<template>
  <div class="illustration-footer-container">
    <div class="illustration-image-container">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
.illustration-footer-container {
  position: fixed;
  z-index: -1;
  background-color: var(--main-primary);
  bottom: 0;
  height: 420px;
  width: 100%;
  overflow: hidden;

  .illustration-image-container {
    position: absolute;
    right: 0;
  }
}
</style>
